<div class="diff-header">
  <p class="diff-title">{{ title }}</p>
</div>
<div class="diff-container">
  <div class="diff-lines">
    @for (line of diffLines; track trackByLineNumber($index, line)) {
      <div
        class="diff-line"
      [ngClass]="{
        'diff-line-added': line.type === 'added',
        'diff-line-removed': line.type === 'removed',
        'diff-line-unchanged': line.type === 'unchanged'
      }"
        >
        @if (line.type === 'added') {
          <span class="diff-prefix">+</span>
        }
        @if (line.type === 'removed') {
          <span class="diff-prefix">-</span>
        }
        @if (line.type === 'unchanged') {
          <span class="diff-prefix">&nbsp;</span>
        }
        <span class="diff-content">{{ line.content }}</span>
      </div>
    }
  </div>
</div>
